<template>
    <div class="appHeaderSearch container">
        <div class="row g-0">
            <div class="col-1 bd-back-header p-0">
                <router-link :to="to" class="headerButton">
                    <ion-icon name="arrow-back-outline" class="custom-arrow-back"></ion-icon>
                </router-link>
            </div>
            <div class="col-2 mt-2 text-left" style=" width: 13%;">
                <!-- <ion-icon class="text-TEAL fs-19" name="location-outline"></ion-icon> -->
                <span class="p-1">مبدا</span>
            </div>

            <div class="col-9" style="width: 78.6%;">
                <div class="form-group mt-1">
                    <div class="input-wrapper">
                        <!-- <ion-icon name="arrow-up-outline"></ion-icon> -->
                        <div class="custom-select-container">
                            <ion-icon name="location-outline" class="custom-arrow"></ion-icon>
                            <select class="form-select border-blue custom-select-arrow-left" @change="changeCityFrom">
                                <option class="fw-bold" selected value="0">اطراف من</option>
                                <option v-for="result in results" :key="result.id" :value="result.id">
                                    {{ result.name }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-1"></div>
            <div class="col-2 mt-2" style="width: 13%;">
                <!-- <ion-icon class="text-TEAL fs-19" name="locate-outline"></ion-icon> -->
                <span class="p-1">مقصد</span>
            </div>

            <div class="col-9" style=" width: 78.6%;">
                <div class="form-group my-2">
                    <div class="input-wrapper">
                        <!-- <ion-icon name="arrow-up-outline"></ion-icon> -->
                        <div class="custom-select-container">
                            <ion-icon name="locate-outline" class="custom-arrow"></ion-icon>
                            <select class="form-select border-blue custom-select-arrow-left" @change="changeCityTo">
                                <option selected>همه استان ها</option>
                                <option v-for="result in results" :key="result.id" :value="result.id">
                                    {{ result.name }}
                                </option>
                            </select>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';

export default {
    props: ['to', 'indexPage', 'title'],
    data() {
        return {
            tel: window.localStorage.getItem("tel"),
            cityTo: [],
            cityFrom: [],
            results: [],
            selectedState: 'انتخاب کنید',
            axiosConfig: {
                headers: {
                    'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
                    'Accept': 'application/json'
                }
            },

        };
    },
    methods: {
        changeCityFrom(event) {
            this.$emit('change_City_From', event.target.value);
        },
        changeCityTo(event) {
            this.$emit('change_City_To', event.target.value);
        },
        changeTitleFleet(value) {
            this.selectedState = value;
        },
        cities() {
            axios.get("https://xpanel.s-bar.ir/api/driver/provinceAndCitiesList", this.axiosConfig)
                .then((response) => {
                    this.results = response.data.data;
                })
                .catch(() => {
                    // Swal.fire({
                    //     position: "center",
                    //     icon: "error",
                    //     title: "لطفا اینترنت خود را بررسی کنید",
                    //     showConfirmButton: true,
                    //     confirmButtonText: "تایید",
                    // });
                });
        },
        backTell() {
            if (history.pushState) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backTell=1';
                window.history.pushState({ path: newurl }, '', newurl);
            }
        }
    },
    mounted() {
        this.cities();
    },
}
</script>
<style scoped>
.border-blue {
    border-color: #4300FF !important;
}

.appHeaderSearch {
    position: fixed;
    top: 0;
    /* مهم: دیگر env استفاده نکن */
    left: 0;
    right: 0;
    z-index: 200;
    background: #FFF;
    color: #141515;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1),
        0 1px 3px 0 rgba(0, 0, 0, 0.08);
}

.custom-arrow-back {
    font-size: 2rem;
    /* Increase the size of the icon */
    /* transform: scaleX(1.1); Stretch the icon horizontally */
}

.custom-select-arrow-left {
    appearance: none;
    /* Remove default arrow */
    -webkit-appearance: none;
    /* For Safari */
    -moz-appearance: none;
    /* For Firefox */
    background-image: url('data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4 5"%3E%3Cpath fill="none" stroke="currentColor" stroke-width=".5" d="M2 0L0 2h4zm0 5L0 3h4z"/%3E%3C/svg%3E');
    background-repeat: no-repeat;
    background-position: left 10px center;
    /* Position the arrow on the left */
    padding-left: 30px;
    /* Adjust padding to make space for the arrow */
}




.custom-arrow {
    position: absolute;
    right: 10px;
    /* Position the icon inside the select on the right */
    top: 50%;
    transform: translateY(-50%);
    pointer-events: none;
    /* Allow clicking through the icon */
    font-size: 20px;
    /* Adjust as needed */
}




.bd-back-header {
    padding: 15px 0px;
    align-self: center;
    text-align: center;
}

.appHeaderSearch .headerButton {
    color: #141515;
}
</style>